import { createAction, props } from '@ngrx/store';
import {
  MfaOriginProductModel,
  ProductCodes,
  TwoFactorTypes,
} from '../../models/user-profile.model';
import { MfaErrors } from './mfa.state';

export const getIsMfaEnabled = createAction(
  '[Login Page] Get Is MFA Enabled',
  props<{
    mfaToken: string;
    productCode: ProductCodes;
    originUrl: string;
  }>(),
);

export const promptMfa = createAction(
  '[Mfa API] Prompt MFA',
  props<{
    originProduct: MfaOriginProductModel;
    originUrl: string;
    twoFactorType: TwoFactorTypes;
  }>(),
);

export const mfaError = createAction(
  '[Mfa API] MFA Error',
  props<{ errorType?: MfaErrors; originUrl?: string }>(),
);

export const authenticateMfaCode = createAction(
  '[Login Page] Authenticate MFA Code',
  props<{ code: string; rememberUser: boolean }>(),
);

export const dismissMfaError = createAction('[Login Page] Dismiss MFA Error');

export const navigateToOrigin = createAction(
  '[Mfa API] Navigate To Origin',
  props<{ originProduct?: MfaOriginProductModel }>(),
);

export const navigateToOriginLogin = createAction(
  '[Two Factor Component] Navigate To Origin Login URL',
  props<{ isTimedOut?: boolean }>(),
);
